export default __webpack_public_path__ + "static/media/about-gallery-1-comp.85c1a33d.jpg";